import { render, staticRenderFns } from "./MailNotify.vue?vue&type=template&id=7f345b3e&scoped=true"
import script from "./MailNotify.vue?vue&type=script&lang=js"
export * from "./MailNotify.vue?vue&type=script&lang=js"
import style0 from "./MailNotify.vue?vue&type=style&index=0&id=7f345b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f345b3e",
  null
  
)

export default component.exports